import React, { MouseEvent } from "react"

import { useSelectedVod, useSetSelectedVod, useVods } from "vod/contexts"

interface Props {
  setIsContinueMessage: React.Dispatch<React.SetStateAction<boolean>>
}

export default function FileList({ setIsContinueMessage }: Props) {
  const vods = useVods()
  const selectedVod = useSelectedVod()
  const setSelectedVod = useSetSelectedVod()

  return (
    <div className="listB">
      <ul>
        {vods.length > 0 &&
          selectedVod &&
          vods.map((vod, i) => {
            return (
              <li key={i}>
                <a
                  href="#!"
                  className={
                    vod.streamUrl === selectedVod.streamUrl ? "on" : ""
                  }
                  onClick={(e: MouseEvent) => {
                    e.preventDefault()
                    setIsContinueMessage(false)
                    setSelectedVod(vod)
                  }}
                >
                  녹화파일 {i + 1}
                </a>
              </li>
            )
          })}
      </ul>
    </div>
  )
}
